import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Toggle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: props.expanded || false,
    };
  }
  componentWillReceiveProps(newProps) {
    if (newProps.expanded && newProps.expanded !== this.state.expanded) {
      this.setState({ expanded: newProps.expanded });
    }
  }
  toggleExpansion() {
    this.setState({ expanded: !this.state.expanded });
  }
  render() {
    return (
      <div className={this.props.className}>
        <A onClick={() => this.toggleExpansion()}>{this.props.expandText || 'Expand'}</A>
        <ToggleDiv expanded={this.state.expanded}>
          {this.props.children}
        </ToggleDiv>
      </div>
    );
  }
}

const expandedStyles = `

`;

const collapsedStyles = `
  height: 0px;
`;

const ToggleDiv = styled.div`
  overflow: hidden;
  ${(props) => props.expanded ? expandedStyles : collapsedStyles}
`;

const A = styled.a`
  color: ${(props) => props.theme.brandPurple};
`;

Toggle.propTypes = {
  expanded: PropTypes.bool,
  expandText: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Toggle;



// WEBPACK FOOTER //
// ./app/components/Toggle/index.js